import { render, staticRenderFns } from "./PartnersCarousel.vue?vue&type=template&id=de37e874&"
import script from "./PartnersCarousel.vue?vue&type=script&lang=js&"
export * from "./PartnersCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports